import React, { FC } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { urls } from 'core/appUrls';
import styles from './RecoveryPasswordLink.module.scss';

const RecoveryPasswordLink: FC = () => {
	return (
		<Link className={cx('link', styles.main)} to={urls.recoveryPassword}>
			Forgot password?
		</Link>
	);
};

export default RecoveryPasswordLink;
